export default {
  query: {
    server: '/monitor/query',
    method: 'post',
  },
  latestQuery: {
    server: '/monitor/latest-query',
    method: 'post',
  },
  latestWeekQuery: {
    server: '/monitor/latestWeek-query',
    method: 'post',
  },
  paginationQuery: {
    server: '/monitor/pagination-query',
    method: 'post',
  },
  delete: {
    server: '/monitor/delete',
    method: 'post',
  },
  getOverview: {
    server: '/monitor/overview',
    method: 'get',
  },
  customFields: {
    server: '/monitor/custom-fields',
    method: 'post',
  },
  // 查询组合测点的分页数据
  masterPaginationQuery: {
    server: '/monitor/master/pagination-query',
    method: 'post',
  },
  // 查询组合测点图表数据
  masterQuery: {
    server: '/monitor/master/query',
    method: 'post',
  },
  // 查询测斜仪上传的时间记录
  queryRdmTimeList: {
    server: '/monitor/rdm/times',
    method: 'post',
  },
  // 图表数据
  rdmChartQuery: {
    server: '/monitor/rdm/chart-query',
    method: 'post',
  },
  // 全站仪查询断面位移数据
  sectionOffsetQuery: {
    server: '/monitor/section/offset/pagination-query',
    method: 'post',
  },
  // 全站仪查询断面收敛数据
  sectionConvergenceQuery: {
    server: '/monitor/section/convergence/pagination-query',
    method: 'post',
  },
  // 全站仪查询断面沉降数据
  sectionSettlementQuery: {
    server: '/monitor/section/settlement/pagination-query',
    method: 'post',
  },
  // 全站仪查询断面弦长数据
  sectionChordQuery: {
    server: '/monitor/section/chord/pagination-query',
    method: 'post',
  },
};
